import ChevronDownCircle from '../../../../Assets/StorefrontIcons/ChevronDownCircle.svg';
import { useDispatch, useSelector } from 'react-redux';
import { setChangeType, setModal, setPagetype, setPageTypeDropdownOpen, setSectionFormType } from '../../../../Features/storefrontSlice';

function Pagetype() {
    const dispatch = useDispatch();

    const pageType = useSelector((state) => state.storefront.pageType);
    const pageTypeDropdownOpen = useSelector((state) => state.storefront.pageTypeDropdownOpen);
    const versionStack = useSelector((state) => state.storefront.versionStack);

    function handleDropdownToggle() {
        dispatch(setPageTypeDropdownOpen(!pageTypeDropdownOpen));
    }

    function updatePagetype(type) {
        if(versionStack.length > 1) {
            dispatch(setChangeType(type));
            dispatch(setModal('confirm-switch-page'));
        }
        else {
            dispatch(setPagetype(type));
            dispatch(setPageTypeDropdownOpen(false));
            dispatch(setSectionFormType(null));
        }
    }

    return (
        <div className="pl-3 flex items-center justify-center gap-[6px] relative">
            <p className='font-normal text-[14px] leading-[22px] text-[#121212]'>Page: {pageType === 'STORE' ? 'Store and deals' : 'About Us'}</p>

            <button onClick={handleDropdownToggle} className="size-[18px] outline-none flex items-center justify-center cursor-pointer">
                <img className='size-full' src={ChevronDownCircle} alt="" />
            </button>

            {
                pageTypeDropdownOpen && 
                <div className="absolute z-10 flex flex-col top-8 left-3 w-64 rounded-lg overflow-hidden border border-[#EAEAEA] shadow-[0_3px_6px_0_#0000001F] font-medium text-[14px] leading-[22px]">
                    <button onClick={() => updatePagetype('STORE')} className={`text-left p-3 outline-none flex items-center gap-[10px] ${pageType === 'STORE' ? 'bg-primaryColor text-buttonText' : 'bg-[#FFFFFF] text-[#666666]'}`}>
                        <p className='w-[calc(100%-24px)]'>Store and deals</p>

                        <div className="size-6 flex items-center justify-center">
                            <img src="" alt="" />
                        </div>
                    </button>

                    <button onClick={() => updatePagetype('ABOUT')} className={`text-left p-3 outline-none flex items-center gap-[10px] ${pageType === 'ABOUT' ? 'bg-primaryColor text-buttonText' : 'bg-[#FFFFFF] text-[#666666]'}`}>
                        <p className='w-[calc(100%-24px)]'>About us</p>

                        <div className="size-6 flex items-center justify-center">
                            <img src="" alt="" />
                        </div>
                    </button>
                </div>
            }
        </div>
    );
}

export default Pagetype;
